/**
 * 《星雲鑑》天星软件权限管理服务
 *
 * 当前统一通过单一权限模式开关控制：
 * - all-open：审核/调试兜底模式，所有权限默认放开
 * - api-controlled：正式权限模式，按后端 bootstrap 返回的权限列表控制
 */
const PERMISSION_MODE_ALL_OPEN = 'all-open'
const PERMISSION_MODE_API_CONTROLLED = 'api-controlled'
const DEFAULT_PERMISSION_MODE = PERMISSION_MODE_API_CONTROLLED
const DEFAULT_PERMISSIONS = [
  'basic_astrolabe',
  'logic_points',
  'full_stars',
  'tianyun',
  'zuoshan_pointer',
  'selection_service',
  'special_courses'
]
const PERMISSION_METADATA = {
  asteroids: '虚星 (ID: 40-47)',
  natal_chart: '本命盘',
  planet_power: '行星的力量 (能量数值)',
  tianyun: '天运 (世纪运)',
  logic_points: '数学逻辑点',
  midpoint_formula: '催贵公式 (中点计算)',
  zuoshan_pointer: '座山指针动态',
  full_stars: '全部恒星可见及容许度设置',
  ephemeris_download: '星历表下载',
  harmonious_phase_search: '和谐相位搜索',
  selection_service: '天星择日',
  special_courses: '专题课/罗盘销售'
}

class PermissionService {
  constructor () {
    this.resetPermissionServiceForTest()
  }

  normalizePermissionMode (mode) {
    const normalizedMode = String(mode || '').trim().toLowerCase()
    if (normalizedMode === PERMISSION_MODE_API_CONTROLLED) {
      return PERMISSION_MODE_API_CONTROLLED
    }
    return PERMISSION_MODE_ALL_OPEN
  }

  setPermissionMode (mode) {
    this.permissionMode = this.normalizePermissionMode(mode)
    return this.permissionMode
  }

  getPermissionMode () {
    return this.permissionMode
  }

  getPermissionModeLabel () {
    return this.isAllOpenMode() ? '权限：全开' : '权限：接口控制'
  }

  isAllOpenMode () {
    return this.permissionMode === PERMISSION_MODE_ALL_OPEN
  }

  /**
   * 初始化/设置用户权限（由后台对接时调用）
   * @param {Array<string>} permissionList 权限名数组
   */
  setPermissions (permissionList) {
    if (!Array.isArray(permissionList)) {
      return this.getPermissions()
    }

    this.permissions = new Set(
      permissionList
        .map(item => String(item || '').trim())
        .filter(Boolean)
    )
    return this.getPermissions()
  }

  /**
   * 检查是否拥有特定模块的权限
   * @param {string} permissionKey 权限键名
   * @returns {boolean}
   */
  hasPermission (permissionKey) {
    if (this.isAllOpenMode()) {
      return true
    }

    const normalizedKey = String(permissionKey || '').trim()
    if (!normalizedKey) {
      return false
    }
    return this.permissions.has(normalizedKey)
  }

  /**
   * 获取当前所有的权限（调试用）
   */
  getPermissions () {
    return Array.from(this.permissions)
  }

  getPermissionMetadata () {
    return { ...PERMISSION_METADATA }
  }

  resetPermissionServiceForTest () {
    this.permissionMode = DEFAULT_PERMISSION_MODE
    this.permissions = new Set(DEFAULT_PERMISSIONS)
  }
}

const permissionService = new PermissionService()

module.exports = permissionService
module.exports.PERMISSION_MODE_ALL_OPEN = PERMISSION_MODE_ALL_OPEN
module.exports.PERMISSION_MODE_API_CONTROLLED = PERMISSION_MODE_API_CONTROLLED
module.exports.DEFAULT_PERMISSION_MODE = DEFAULT_PERMISSION_MODE
